<!--
 * @Author: tony.zhu
 * @Date: 2025-10-16 11:56:28
 * @LastEditTime: 2025-12-04 10:59:31
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <markdown-it-vue
    ref="markdownItVue"
    :class="{ isCollapse }"
    :content="content"
    :options="{ markdownIt: { breaks: true } }"
  />
</template>

<script>
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
import "highlight.js/styles/github-dark.css";

export default {
  components: { MarkdownItVue },
  props: {
    content: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isCollapse: false,
      timer: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.$nextTick(() => {
      this.$el.addEventListener("click", (e) => {
        if (
          e.target.classList.value.indexOf("#icon-xiangshangjiantouIcon") >
            -1 ||
          e.target.parentNode.classList.value.indexOf(
            "#icon-xiangshangjiantouIcon"
          ) > -1
        ) {
          this.isCollapse = !this.isCollapse;
        }
      });
    });

    this.timer = setInterval(() => {
      if (this.beginThinkTick()) {
        if (this.endThinkTick()) {
          clearInterval(this.timer);
        }
      }
    }, 1000);

    const thinkPlugin = (md) => {
      md.renderer.rules.text = (tokens, idx) => {
        const content = tokens[idx].content;
        if (content.indexOf("<think>") >= 0) {
          let text = "已深度思考";
          if (!this.beginThinkTick()) {
            localStorage.setItem(
              `${this.id}beginThinkTickByAiChat`,
              Date.now()
            );
          } else {
            const time =
              (this.endThinkTick() || Date.now()) - this.beginThinkTick();
            const second = time / 1000;
            if (second > 1) {
              text = `已深度思考 (${Math.ceil(second)}秒)`;
            }
          }
          return `<div class="think">
            <div class="think_title"><span class="think_time">${text}</span>
              <svg class="icon iconfont #icon-xiangshangjiantouIcon" aria-hidden="true">
                <use xlink:href="#icon-xiangshangjiantouIcon" />
              </svg>
            </div>
            <div class="think_content">${content}`;
        } else if (content.indexOf("</think>") >= 0) {
          if (!this.endThinkTick()) {
            localStorage.setItem(
              `${this.id}endThinkTickByAiChat`,
              Date.now()
            );
          }
          return `${content}</div></div>`;
        }
        return content;
      };
    };

    // 注册插件（在原有插件之前）
    this.$refs.markdownItVue.use(thinkPlugin);
  },
  methods: {
    beginThinkTick() {
      const beginThinkTick = localStorage.getItem(
        `${this.id}beginThinkTickByAiChat`
      );
      return beginThinkTick ? parseInt(beginThinkTick) : 0;
    },
    endThinkTick() {
      const endThinkTick = localStorage.getItem(
        `${this.id}endThinkTickByAiChat`
      );
      return endThinkTick ? parseInt(endThinkTick) : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.md_body {
  &.isCollapse {
    ::v-deep .think {
      .think_content {
        display: none;
      }
      .icon {
        transform: rotate(180deg);
      }
    }
  }
}

::v-deep .think {
  overflow: hidden;
  color: #86909c;
  font-size: 12px;
  white-space: nowrap;
  .think_content {
    display: block;
    border-left: solid 2px #ededed;
    padding-left: 12px;
    white-space: pre-line;
  }
  .think_title {
    margin-bottom: 8px;
  }
  .icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    vertical-align: text-bottom;
  }
}
</style>